import React from 'react'

// Percentage or a flat program fee, for one client.
//
// The office grants the OPTION (customSettings.flatFeeAllowed); the person enrolling decides for
// this client. Percentage is the default everywhere, including on an office that permits flat — a
// flat fee is chosen, never something that happens to a client because of where they enrolled.
//
// Shared by the onboarding screen (Add Contact) and the back-office regenerate-plan modal, so the
// two cannot drift into offering different things.
//
// `flatOnly` (WS #2219702): the office enrols on a flat fee only, so there is nothing to choose. Only
// Add Contact passes it; the regenerate-plan modal keeps both options.
const FeeShapeChoice = ({ allowed, isFlat, onPick, flatOnly = false }) => {
  if (!allowed || flatOnly) return null

  return (
    <div className="w-full flex flex-row items-center gap-6 mb-2">
      <label className="flex items-center gap-2 cursor-pointer">
        <input type="radio" name="feeShape" aria-label="Percentage"
          checked={!isFlat} onChange={() => onPick('percent')} />
        <span className="text-sm text-text-primary">Percentage</span>
      </label>
      <label className="flex items-center gap-2 cursor-pointer">
        <input type="radio" name="feeShape" aria-label="Flat fee"
          checked={isFlat} onChange={() => onPick('flat')} />
        <span className="text-sm text-text-primary">Flat fee</span>
      </label>
    </div>
  )
}

export default FeeShapeChoice
